import axios, { AxiosRequestConfig, AxiosResponse } from "axios";

export interface getVocData_Item {
  station_id: string;
  date: string;
  hour: number;
  minutes: number;
  voc_avg: string;
  voc_max: string;
  voc_min: string;
}

export interface getVocData_Returns {
  status: string;
  count: number;
  data: getVocData_Item[];
}

export const getVocData = async (): Promise<
  AxiosResponse<getVocData_Returns>
> => {
  const config: AxiosRequestConfig = {
    method: "get",
    url: `https://caaqms.wbpcb.wtlprojects.com:9100/voc/get_historic_data?station_id=1&frequency=24hours&start_time=${""}&end_time=${""}`,
  };
  const result: AxiosResponse<getVocData_Returns> = await axios(config);
  return result;
};
